import React from 'react';
import _ from 'lodash';

import {Accordion, Button} from '../index';
import Config from '../../utils/Configuration';
import Utility from '../../utils/Helper';
import Price from '../Label/Price';

const PlanCard = ({
    plan = {},
    promotionRebateInfo,
    addPriceBottomPadding,
    addPriceTopPadding,
    buttonLabel,
    action,
    title,
    descriptionMinHeight = 0,
    cardMinHeight = 0
}) => {
    const showPlanCard = () => {
        const {planDetails = {}, planInfo = {}, planShortName} = plan;
        const {descriptionList = [], benefits = [], recommended = {}, mainPackage = {}, packageInclude = {}} = planInfo;
        const [speed, unit] = (planShortName || '').split(' ');

        const rrpPrice = Utility.getValues(plan, 'pricing.rrpPrice');

        const commonHeight24pxStyle = {height: '24px'};

        const generateDescriptionTitle = (icon, tagName, title) => {
            return (
                <div className='d-flex'>
                    <div>
                        <img
                            className='description-icon'
                            src={`${Config.apiConfig.aemEndPoint}${icon}`}
                            alt='description_icon'
                        />
                    </div>
                    <div
                        className={`ms-2 d-flex flex-column ${
                            tagName ? 'justify-content-between' : 'justify-content-center'
                        }`}
                    >
                        {tagName && (
                            <div>
                                <span className='blue-tag fs-12 maxis-semiBold text-white ls-100 bg-lightish-blue'>
                                    {tagName}
                                </span>
                            </div>
                        )}
                        <div className='fs-14 text-black maxis-semiBold lh-normal mb-0 mt-1'>{title}</div>
                    </div>
                </div>
            );
        };

        const generateBenefitTitle = (tagName, title) => {
            return (
                <div className='lh-17px'>
                    {tagName && (
                        <span className='blue-tag fs-12 maxis-semiBold text-white ls-100 bg-lightish-blue me-2'>
                            {tagName}
                        </span>
                    )}
                    <span className='fs-14 text-black maxis-bold'>{title}</span>
                </div>
            );
        };

        const generateMainPackageTitle = (title) => {
            return <div className='fs-16 text-frog-green maxis' dangerouslySetInnerHTML={{__html: title}} />;
        };

        const generatePackageTitle = (title) => {
            return <div className='fs-14 text-black maxis-bold'>{title}</div>;
        };

        return (
            <div className='plan-card'>
                <div className='card plane m-0 position-relative' style={{minHeight: cardMinHeight}}>
                    {planDetails.tagName && (
                        <div className='position-absolute left-0 top-0 w-100 d-flex justify-content-center'>
                            <div className='header-tag'>{planDetails.tagName}</div>
                        </div>
                    )}
                    <div className='body-card cursor-pointer d-flex flex-column justify-content-between'>
                        <div>
                            <h2 className='plan-name text-dark-blue-3 mb-17px maxis-bold'>
                                <span className='mb-2px fs-16 lh-18px'>{title}</span>
                                <span className='d-block'>
                                    <span className='fs-35 lh-120 me-1'>{speed}</span>
                                    <span className='fs-24 lh-117'>{unit}</span>
                                </span>
                            </h2>

                            <div className='description-list'>
                                {(descriptionList || []).map((item, index) => {
                                    return (
                                        <div
                                            key={`description_list_${index}`}
                                            className={`description-item position-relative ${
                                                index > 0 ? 'mt-15px' : ''
                                            } ${item.tagName ? 'show-tag' : ''}`}
                                        >
                                            <Accordion
                                                title={generateDescriptionTitle(item.icon, item.tagName, item.title)}
                                                isAccordionArrow
                                            >
                                                {(item.subDescriptionList || []).length > 0 && (
                                                    <div className='pt-10px ps-4 mb-0'>
                                                        {item.subDescriptionList.map((text, subIndex) => (
                                                            <div
                                                                key={`sub_description_${subIndex}`}
                                                                className='fs-14 text-gunmetal lh-18px'
                                                                dangerouslySetInnerHTML={{
                                                                    __html: text
                                                                }}
                                                            />
                                                        ))}
                                                    </div>
                                                )}
                                            </Accordion>
                                        </div>
                                    );
                                })}

                                {!_.isEmpty(recommended) && (
                                    <div className='description-item position-relative mt-15px'>
                                        <Accordion
                                            title={generateDescriptionTitle(
                                                recommended.iconPath,
                                                null,
                                                recommended.title
                                            )}
                                            isAccordionArrow
                                            hardActive
                                        >
                                            {(recommended.recommendedList || []).length > 0 && (
                                                <div className='pt-10px ps-4 mb-0'>
                                                    {recommended.recommendedList.map((recText, recIndex) => (
                                                        <div
                                                            key={`recommended_item_${recIndex}`}
                                                            className='fs-14 text-gunmetal lh-18px'
                                                            dangerouslySetInnerHTML={{
                                                                __html: recText
                                                            }}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </Accordion>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div>
                            <div className={`mt-25px mb-18px maxis-bold text-dark-blue-3 text-center`}>
                                {promotionRebateInfo && (
                                    <div className='maxis text-brown-grey text-center strike-through'>
                                        <Price className='fs-16' price={plan.planPrice} mth />
                                    </div>
                                )}
                                {addPriceTopPadding && <div style={commonHeight24pxStyle}></div>}
                                <Price
                                    className='fs-24'
                                    numberClass='fs-35 lh-100'
                                    mthClass='fs-18 fs-md-24'
                                    price={
                                        Number(plan.planPrice) -
                                            (Number.isNaN(Number(promotionRebateInfo?.rebateAmount))
                                                ? 0
                                                : Number(promotionRebateInfo?.rebateAmount)) ?? '--'
                                    }
                                    mth
                                />
                                {!promotionRebateInfo && rrpPrice && (
                                    <div
                                        className='maxis text-brown-grey text-center strike-through'
                                        style={commonHeight24pxStyle}
                                    >
                                        <Price className='fs-16' price={rrpPrice} mth />
                                    </div>
                                )}
                                {promotionRebateInfo && (
                                    <div className='text-dark-blue-3 text-center fs-16' style={commonHeight24pxStyle}>
                                        {promotionRebateInfo.rebateMonthsLabel}
                                    </div>
                                )}
                                {addPriceBottomPadding && <div style={commonHeight24pxStyle}></div>}
                            </div>

                            <div className='plan-action mb-15px mt-20px'>
                                <Button
                                    onClick={() => action(plan)}
                                    buttonClass='primary text-uppercase mb-0 ls-150 button-hover-anim '
                                    buttonLabel={buttonLabel}
                                />
                            </div>

                            <div className='plan-benefits'>
                                {(benefits || []).map((benefitItem, benefitIndex) => {
                                    return (
                                        <div key={`benefits_item_${benefitIndex}`} className='mb-2px'>
                                            <Accordion
                                                title={generateBenefitTitle(benefitItem.tagName, benefitItem.title)}
                                                isAccordionArrow
                                            >
                                                {benefitItem.description && (
                                                    <span className='fs-14 text-gunmetal lh-18px mt-1px'>
                                                        {benefitItem.description}
                                                    </span>
                                                )}
                                            </Accordion>
                                        </div>
                                    );
                                })}
                            </div>

                            {!_.isEmpty(mainPackage) && (
                                <div className='mt-15px'>
                                    {generateMainPackageTitle(mainPackage.title)}
                                    {(mainPackage.mainPackageList || []).length > 0 && (
                                        <ul className='pt-1 pl-20px mb-0'>
                                            {mainPackage.mainPackageList.map((mainPackText, mainPackIndex) => {
                                                return (
                                                    <li
                                                        key={`main_package_item_${mainPackIndex}`}
                                                        className='fs-14 text-brown-grey lh-18px'
                                                    >
                                                        {mainPackText}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </div>
                            )}

                            {!_.isEmpty(packageInclude) && (
                                <div className='mt-15px'>
                                    <Accordion title={generatePackageTitle(packageInclude.title)} isAccordionArrow>
                                        {(packageInclude.packageIncludeList || []).length > 0 && (
                                            <ul className='pt-1 pl-20px mb-0'>
                                                {packageInclude.packageIncludeList.map((packText, packIndex) => {
                                                    return (
                                                        <li
                                                            key={`package_item_${packIndex}`}
                                                            className='fs-14 text-gunmetal lh-18px'
                                                        >
                                                            {packText}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        )}
                                    </Accordion>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return showPlanCard();
};

export default PlanCard;
